<div class="appearance-control">
  <button
    #appearanceTrigger
    type="button"
    class="appearance-trigger"
    (click)="toggleControls(); $event.stopPropagation()"
    aria-haspopup="dialog"
    [attr.aria-expanded]="showControls"
    [attr.aria-controls]="controlsId"
  >
    <span aria-hidden="true">◐</span>
    <span class="appearance-trigger-label">Appearance</span>
  </button>
</div>
